import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestResponse } from '../model/dto/RequestResponse';
import { PositionStore } from '../model/PositionStore';
import { PositionStoreParamsStos } from '../model/dto/PositionStoreParamsDtos';

@Injectable()
export class PositionStoreFacade {
    private _urlBase: string;
    private _httpClient: HttpClient;

    constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this._urlBase = baseUrl;
        this._httpClient = http;
    }

    GetPositionStore(): Observable<RequestResponse<[PositionStore]>> {
        return this._httpClient.get<RequestResponse<[PositionStore]>>(this._urlBase + 'api/PositionStore');
    }

    GetPositionStoreByPositionId(positionId: number): Observable<RequestResponse<[PositionStore]>> {
        return this._httpClient.get<RequestResponse<[PositionStore]>>(this._urlBase + 'api/PositionStore/' + positionId);
    }

    GetPositionStoreGetAllByEmail(employeeEmail: string): Observable<RequestResponse<PositionStore[]>> {
        return this._httpClient.get<RequestResponse<PositionStore[]>>(this._urlBase + 'api/PositionStore/StoreGetAllByEmail?employeeEmail=' + employeeEmail);
    }
    PostPosition(request: PositionStoreParamsStos): Observable<RequestResponse<number>> {
        return this._httpClient.post<RequestResponse<number>>(this._urlBase + 'api/PositionStore', request);
    }

    DeletePosition(idPositionStore: number): Observable<RequestResponse<boolean>> {
        return this._httpClient.delete<RequestResponse<boolean>>(this._urlBase + 'api/PositionStore/' + idPositionStore);
    }
    DeletePositionList(PositionStore: any[]): Observable<RequestResponse<boolean>> {
        return this._httpClient.post<RequestResponse<boolean>>(this._urlBase + 'api/PositionStore/DeleteList', PositionStore);
    }

}
